import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

export default function Support() {
  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white">
      <NavbarV2 />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-50 to-emerald-50 py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Destek & İletişim</h1>
            <p className="text-lg text-gray-600 mb-6">
              Size nasıl yardımcı olabiliriz? Sorularınız için buradayız.
            </p>
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
              <span className="mx-2">/</span>
              <span className="text-red-500">Destek</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white border rounded-xl p-8 shadow-sm">
              {/* Contact Info */}
              <div className="mb-12">
                <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">İletişim Bilgileri</h2>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8 rounded-lg">
                  <div className="flex items-center justify-center mb-4">
                    <svg className="w-8 h-8 text-blue-600 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800">E-posta</h3>
                      <p className="text-gray-600">Her türlü soru, öneri ve geri bildirim için</p>
                    </div>
                  </div>
                  <div className="text-center">
                    <a 
                      href="mailto:gudersamet@gmail.com" 
                      className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
                    >
                      <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      gudersamet@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Support Topics */}
              <div className="space-y-8">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-6">Yardım Konuları</h2>
                  <div className="grid md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-6 rounded-lg">
                      <div className="flex items-center mb-4">
                        <svg className="w-6 h-6 text-green-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-800">Teknik Destek</h3>
                      </div>
                      <ul className="text-gray-600 space-y-2 text-sm">
                        <li>• Uygulama hataları</li>
                        <li>• Giriş sorunları</li>
                        <li>• Performans problemleri</li>
                        <li>• Özellik kullanım yardımı</li>
                      </ul>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                      <div className="flex items-center mb-4">
                        <svg className="w-6 h-6 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a2 2 0 01-2-2v-6a2 2 0 012-2h8z" />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-800">Hesap İşlemleri</h3>
                      </div>
                      <ul className="text-gray-600 space-y-2 text-sm">
                        <li>• Hesap oluşturma</li>
                        <li>• Şifre sıfırlama</li>
                        <li>• Profil güncellemeleri</li>
                        <li>• Hesap silme talepleri</li>
                      </ul>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                      <div className="flex items-center mb-4">
                        <svg className="w-6 h-6 text-purple-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-800">Grup Yönetimi</h3>
                      </div>
                      <ul className="text-gray-600 space-y-2 text-sm">
                        <li>• Grup oluşturma</li>
                        <li>• Üye daveti</li>
                        <li>• İlerleme takibi</li>
                        <li>• Yönetici hakları</li>
                      </ul>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-lg">
                      <div className="flex items-center mb-4">
                        <svg className="w-6 h-6 text-red-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                        <h3 className="text-lg font-semibold text-gray-800">Bağış & Destek</h3>
                      </div>
                      <ul className="text-gray-600 space-y-2 text-sm">
                        <li>• Bağış yapma</li>
                        <li>• Ödeme sorunları</li>
                        <li>• Fatura talepleri</li>
                        <li>• İade işlemleri</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Hesap Silme</h2>
                  <div className="text-gray-700">
                    <p className="mb-4">
                      Hesabınızı ve tüm verilerinizi kalıcı olarak silmek istiyorsanız, 
                      detaylı talimatlar için aşağıdaki sayfayı ziyaret edin:
                    </p>
                    <Link 
                      to="/account-deletion" 
                      className="inline-flex items-center px-4 py-2 bg-red-50 text-red-700 font-medium rounded-lg hover:bg-red-100 transition-colors border border-red-200"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                      Hesap & Veri Silme Talimatı
                    </Link>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Bağışlar Hakkında</h2>
                  <div className="text-gray-700">
                    <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200">
                      <div className="flex items-start">
                        <svg className="w-6 h-6 text-yellow-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div>
                          <h3 className="font-semibold text-yellow-800 mb-2">Bağış Güvenliği</h3>
                          <p className="text-yellow-700 text-sm">
                            Bağışlar tamamen gönüllüdür ve İyzico güvenli ödeme altyapısı üzerinden işlenir. 
                            Kart verileriniz bizim sunucularımızda saklanmaz ve işlem tamamen güvenli bir şekilde gerçekleşir.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Yanıt Süreleri</h2>
                  <div className="text-gray-700">
                    <div className="grid md:grid-cols-3 gap-4">
                      <div className="text-center p-4 bg-green-50 rounded-lg">
                        <div className="text-2xl font-bold text-green-600 mb-2">24 Saat</div>
                        <p className="text-sm text-green-700">Teknik Destek</p>
                      </div>
                      <div className="text-center p-4 bg-blue-50 rounded-lg">
                        <div className="text-2xl font-bold text-blue-600 mb-2">48 Saat</div>
                        <p className="text-sm text-blue-700">Genel Sorular</p>
                      </div>
                      <div className="text-center p-4 bg-purple-50 rounded-lg">
                        <div className="text-2xl font-bold text-purple-600 mb-2">72 Saat</div>
                        <p className="text-sm text-purple-700">Hesap İşlemleri</p>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 mt-4 text-center">
                      * Yanıt süreleri ortalama değerlerdir ve duruma göre değişiklik gösterebilir.
                    </p>
                  </div>
                </section>
              </div>

              {/* Related Pages */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                <div className="grid md:grid-cols-3 gap-4">
                  <Link 
                    to="/privacy-policy" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Gizlilik Politikası</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Verilerinizin güvenliği hakkında
                    </p>
                  </Link>
                  <Link 
                    to="/terms-of-service" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Kullanım Koşulları</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Uygulama kullanım kuralları
                    </p>
                  </Link>
                  <Link 
                    to="/account-deletion" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Hesap & Veri Silme</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Hesap silme talimatları
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterV2 />
    </div>
  );
}
